
















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Crossroad, ICrossroadItemModel, CrossroadItemModel } from "@/components/crossroad";
import { getEclientLink, getMappLink } from "@/app/utils/EnvConfig";

@Component({
    components: {
        Crossroad
    }
})
export default class Result extends Vue {
    private get items(): ICrossroadItemModel[] {
        return [
            new CrossroadItemModel(
                require("@/assets/mapp.png"),
                `${require("@/assets/mapp@2x.png")} 2x, ${require("@/assets/mapp@3x.png")} 3x`,
                this.$localize("pwd.set.result.mobile.app.title"),
                this.$localize("pwd.set.result.mobile.app.info"),
                getMappLink(),
                this.$localize("pwd.set.result.mobile.app.link")
            ),
            new CrossroadItemModel(
                require("@/assets/eclient.png"),
                `${require("@/assets/eclient@2x.png")} 2x, ${require("@/assets/eclient@3x.png")} 3x`,
                this.$localize("pwd.set.result.eclient.title"),
                this.$localize("pwd.set.result.eclient.info"),
                getEclientLink(),
                this.$localize("pwd.set.result.eclient.link")
            ),
            new CrossroadItemModel(
                require("@/assets/installments.png"),
                `${require("@/assets/installments@2x.png")} 2x, ${require("@/assets/installments@3x.png")} 3x`,
                this.$localize("pwd.set.result.installments.title"),
                this.$localize("pwd.set.result.installments.info")
            ),
            new CrossroadItemModel(
                require("@/assets/flex-loan.png"),
                `${require("@/assets/flex-loan@2x.png")} 2x, ${require("@/assets/flex-loan@3x.png")} 3x`,
                this.$localize("pwd.set.result.flexLoan.title"),
                this.$localize("pwd.set.result.flexLoan.info")
            )
        ];
    }
}
